import { render, staticRenderFns } from "./AirRefundable.vue?vue&type=template&id=824af7d2&"
import script from "./AirRefundable.vue?vue&type=script&lang=js&"
export * from "./AirRefundable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports